export class Feriado {
    id: number;
    descricao: number;
    data: Date;
    usuarioAlteracao: number;
}






